import { render } from "./ica.vue?vue&type=template&id=5a588ca1&scoped=true"
const script = {}

import "./ica.vue?vue&type=style&index=0&id=5a588ca1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a588ca1"]])

export default __exports__